import Api from '.';

class JobApi extends Api {
  base_endpoint = 'jobs';

  stop(jobId) {
    return this.doRequest('post', `${jobId}/stop`);
  }

  rerun(jobId) {
    return this.doRequest('put', `${jobId}/rerun`);
  }

  getWarnings(jobId) {
    return this.doRequest('get', `${jobId}/warnings`);
  }
}

export default new JobApi();
